const toRadians = (degrees) => (degrees * Math.PI) / 180;

export function calculateDistanceMeters(lat1, lon1, lat2, lon2) {
  const earthRadius = 6371000;
  const deltaLat = toRadians(Number(lat2) - Number(lat1));
  const deltaLon = toRadians(Number(lon2) - Number(lon1));
  const a =
    Math.sin(deltaLat / 2) ** 2 +
    Math.cos(toRadians(Number(lat1))) *
      Math.cos(toRadians(Number(lat2))) *
      Math.sin(deltaLon / 2) ** 2;
  return earthRadius * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

export function isValidCoordinate(latitude, longitude) {
  const lat = Number(latitude);
  const lng = Number(longitude);
  return Number.isFinite(lat) && Number.isFinite(lng) && lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180;
}

export function getCurrentPosition(options = {}) {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(Object.assign(new Error('Geolocation is not supported by this device or browser.'), { code: 'UNSUPPORTED' }));
      return;
    }

    navigator.geolocation.getCurrentPosition(resolve, reject, {
      enableHighAccuracy: true,
      timeout: 15000,
      maximumAge: 0,
      ...options,
    });
  });
}

export function getGeolocationErrorMessage(error) {
  if (error?.code === 1) {
    return 'Location access is required. Turn on Location Services and allow Pravah to access your location, then try again.';
  }
  if (error?.code === 2) {
    return 'Your location could not be detected. Turn on Location Services, move to an open area and try again.';
  }
  if (error?.code === 3) {
    return 'Location detection timed out. Move to an open area and try again.';
  }
  return error?.message || 'Location could not be detected. Please try again.';
}
